export default {
  data() {
    return {
      pwd: null,
      pwd1: null,
      incorrectPwd: false
    }
  },
  computed: {
    error() {
      if (this.pwd == '') {
        return 1
      
      } else if (this.pwd !== this.pwd1) {
        return 2
      
      } else {
        return null
      }
    }
  }
}
